import React, { useState } from 'react'
import {
  Label,
  InputStyled,
  IconWrapper,
  ClearBtn,
} from './styles'
import { Cross } from 'icons'

const InputOld = ({
  id,
  name,
  value,
  placeholder,
  onChange,
  onClear,
  autoComplete,
  autoFocus,
  iconURL,
  renderIcon: Icon,
}) => {
  const [isFocus, setIsFocus] = useState(false)

  const handleChange = (e) => onChange(e.target.value)

  return (
    <>
      <Label
        htmlFor={id}
        $isFocus={isFocus}
        onFocus={() => setIsFocus(true)}
        onBlur={() => setIsFocus(false)}
      >
        {Icon && (
          <IconWrapper $isFocus={isFocus}>
            <Icon height={14} width={14}/>
          </IconWrapper>
        )}

        <InputStyled
          name={name}
          id={id}
          value={value}
          placeholder={placeholder}
          onChange={handleChange}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          iconURL={iconURL}
        />

        {value && onClear && (
          <ClearBtn
            size='small'
            variant='icon-transparent'
            onClick={onClear}
          >
            <Cross height={15} />
          </ClearBtn>
        )}
      </Label>

      {/* Put here error msg */}
    </>
  )
}

export default InputOld